module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AL-4034b64b9bdf2c6010058ccee3324776.png";